import { io } from "socket.io-client";
import { ENV } from "../config/env";

export const socket = io(ENV.SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});
